import { render, staticRenderFns } from "./Shopify.vue?vue&type=template&id=017f1a55&scoped=true"
import script from "./Shopify.vue?vue&type=script&lang=js"
export * from "./Shopify.vue?vue&type=script&lang=js"
import style0 from "./Shopify.vue?vue&type=style&index=0&id=017f1a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017f1a55",
  null
  
)

export default component.exports